import React, { useEffect, useState } from "react";
import topFlowerImg from "../../assets/images/svg/top_flower.svg";
import bottomFlowerImg from "../../assets/images/svg/bottom_flower.svg";
import greatSoulImg from "../../assets/images/the-great-souls/png/temple_the_great_souls.png";
import greatDecorate from "../../assets/images/coursesPage/LordGaveBapu/png/bapuBgDecorate.png";
import orangeTick from "../../assets/images/svg/orenge_tick.svg";
import Button from "../common/button/Button";
import CommonHeading from "../common/heading/CommonHeading";
import { ModalList } from "../../utils/TheGreateSageHelper";
import Modal from "../common/modal/Modal";
import { greateSageMaiyashree } from "../../utils/TheGreateSageHelper";


const TheGreatSage = () => {
  const [popupOpen, setPopupOpen] = useState(null);

  function showPopup(index) {
    setPopupOpen(popupOpen === index ? null : index);
  }

  const isModalOpen = popupOpen !== null;
  useEffect(() => {
    if (isModalOpen) {
      document.getElementById("html").classList.add("overflow-hidden");
    } else {
      document.getElementById("html").classList.remove("overflow-hidden");
    }

    // Cleanup on component unmount
    return () => {
      document.getElementById("html").classList.remove("overflow-hidden");
    };
  }, [isModalOpen]);
  return (
    <>
      <div className="position-relative great_souls pt-2">
        {/*<img
          className="position-absolute bottom_flower_mahamantra end-0 maharaj_top z_index_n2"
          src={bottomFlowerImg}
          alt="bottom_flower"
        />*/} 
        <img
          src={greatSoulImg}
          className="w-25 position-absolute start-0"
          style={{ bottom: "-10%" }}
          alt="temple_the_great_souls"
        />
        <img
          src={greatDecorate}
          className="bapuBgDecorate position-absolute start-0 d-none d-sm-block"
          alt="bapuBgDecorate"
        />
        <img
          src={greatDecorate}
          className="bapuBgDecorate position-absolute end-0 d-none d-sm-block"
          alt="bapuBgDecorate"
        />
        {/*<img
          className="position-absolute top_flower_mahamantra souls_top_flower start-0 the_great_flower"
          src={topFlowerImg}
          alt="top_flower"
        />*/}

        <div className="container_modified container position-relative mt-0 pt-3 pt-sm-4">
          <div className="row justify-content-center mt-xl-2">
            <div className="col-lg-11 text-center mb-4 pb-lg-2">
              <CommonHeading
                heading="Sidhha Yogini"
                className="text-orange common_heading_text common_heading_text_brown"
              />
              <h2 className="common_sub_heading text-center mb-1 mb-md-3 px-4 px-md-0">
                P.P. Maiyashree ShailajaDevi
              </h2>
            </div>
          </div>
          <div className="row justify-content-between mb-3 pb-3">
            <div className="col-lg-7">
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-5">
                Just like Maharshi Shri, it is difficult to describe in words anything about Poojya Maiyashree also. How can one know the mysteries of the life of a great person who has elevated himself to the stage of Sadguru? Yes, one thing can be said with certainty that this gross body of Poojya Maiyashree assumed human form in a highly religious family. 
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-4">
                Maiyashree used to carry out bhajan-sadhana for six to eight hours a day even during the study days and subtle bodied Siddhas and saints used to guide her during sadhana period. 
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-4">
                According to indications of siddhas and saints, she discontinued food grains in her diet and started living only on fruits. It was during this period that with the grace of siddhas she completed practically all the activities concerning Hatha yoga and also carried out Khiechari Mudra successfully.
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-3">
                Such assiduous sadhana is possible only with the grace of Sadguru and fruits of virtuous actions of the current and past lives. Sadhana of Ma pleased Sadguru, earned her the blessings of Gods and Goddesses and on the guidance of Sadguru, she joined Poojyashri to follow Rishi tradition.
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-sm-5">
                  It is highly commendable on the part of Maiyashree that she is not only looking after the activities of Girnar Sadhana Ashram at Junagadh but also getting an aesthetically beautiful and imposing building constructed for the Ashram on the banks of Ganges in Rishikesha-Lakshman-Jhula.
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-sm-5">
                It is not possible to describe Poojya Maiyashree personality but it is not an exaggeration that she is like Goddess Saraswati in writing and speaking, Goddess Lakshmi in generosity and Goddess Kali in not tolerating injustice, impropriety and atrocity. She is a mother to all. Many salutations to Maiyashree
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-5 ps-lg-0 mx-auto mt-4 mt-lg-0">
              {greateSageMaiyashree.map((obj, index) => {
                return (
                  <div
                    className="position-relative z-3 text-center"
                    key={index}
                    onClick={() => showPopup(index)}
                  >
                    <div className="position-absolute w-100 d-flex justify-content-center bottom-0 pb-4 pb-lg-5 mb-3 mb-lg-2">
                      <Button title={obj.title} className="great_sage_btn" />
                    </div>
                    <img
                      src={obj.image}
                      className="w-100 max_sm_w cursor_pointer"
                      alt="sage-bapu-img"
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div
          className="nav_overlay position-fixed top-0 start-0 vh-100 w-100 z_index_4"
          onClick={() => setPopupOpen(null)}
        ></div>
      )}
      {isModalOpen && (
        <Modal
          data={ModalList[popupOpen]}
          showPopup={() => setPopupOpen(null)}
        />
      )}
    </>
  );
};

export default TheGreatSage;
